import { Link, Typography } from '@material-ui/core';
import { MobileAppBridge } from 'shared/data/MobileAppBridge';

interface NotificationSettingContactsUpdatePhoneMobileProps {
  type: 'carrier' | 'dispatcher';
}

export function NotificationSettingContactsUpdatePhoneMobile({
  type,
}: NotificationSettingContactsUpdatePhoneMobileProps) {
  return type === 'carrier' ? (
    <Typography color="textSecondary">
      Update at{' '}
      <Link
        type="button"
        color="primary"
        component="button"
        onClick={() => MobileAppBridge.openCarrierInformation()}
      >
        Contact Info
      </Link>
    </Typography>
  ) : (
    <Typography color="textSecondary">
      Update at{' '}
      <Link
        type="button"
        color="primary"
        component="button"
        onClick={() => MobileAppBridge.openDriverInformation()}
      >
        Driver Information
      </Link>
    </Typography>
  );
}
